import { h } from 'preact';
import { useEffect, useState } from 'preact/hooks';

const READY = 0;
const LOADING = 1;
// const DOWNLOADED = 2;

const DownloadButton = ({canvasRef, downloadMessage}) => {

  const [status, setStatus] = useState(READY);
  const [imageBlob, setImageBlob] = useState("");
  let linkRef;

  useEffect(() => {
    if(imageBlob) {
      linkRef.click();
    }
    setStatus(READY);
  }, [imageBlob]);
  
	const download = () => {
		if (!canvasRef) {
      console.log("no canvas ref yet, how did you even click this");
			return;
		}
    if (status == LOADING) {
      console.log("i'm already loading");
      return;
    }

    setStatus(LOADING);
    const newBlob = canvasRef.elt.toDataURL('image/jpeg');
    if (imageBlob == newBlob) {
      linkRef.click();
      setStatus(READY);
    } else {
      setImageBlob(newBlob);
    }
	}

  const attachLink = (el) => {
    linkRef = el;
  }

  return (
    <div>
      <button className="button-large" disabled={status == LOADING} onClick={download}>download</button>
      <a className="hidden" ref={attachLink} href={imageBlob} download>secretDownloadLink</a>      
    </div>
  )

}

export default DownloadButton;